import { create } from "zustand"
import { persist } from "zustand/middleware"

interface ReferralState {
  ref: string | null
  setRef: (ref: string | null) => void
  clearRef: () => void
}

export const useReferralStore = create<ReferralState>()(
  persist(
    (set) => ({
      ref: null,
      setRef: (ref) => set({ ref }),
      clearRef: () => set({ ref: null }),
    }),
    {
      name: "referral-storage",
    }
  )
) 